import { SagaIterator } from 'redux-saga';
import { HVAC_CHANGE, HVAC_HIDE_ACCURACY_WARNING } from 'src/modules/hvac/actions/HvacActions';
import { hvacChangeSaga } from 'src/modules/hvac/sagas/hvacChangeSaga';
import { hvacHideAccuracyWarningSaga } from 'src/modules/hvac/sagas/hvacHideAccuracyWarningSaga';
import { takeEvery, takeLatest } from 'typed-redux-saga';

export function* hvacSaga(): SagaIterator<void> {
  yield* takeLatest(HVAC_CHANGE.is, hvacChangeSaga);
  yield* takeEvery(HVAC_HIDE_ACCURACY_WARNING.is, hvacHideAccuracyWarningSaga);
}
